import ApiService from '@/services/api'
import { defineStore } from 'pinia'
//import { taskUpdateService } from '@/rxjsServices';

const ENDPOINT = '/quizzes/'
const ITEM_ID  = 'qiz_id'

export const useQuizStore = defineStore('quizzes', {
    //storage option
    persist: true,
    // convert to a function
    state: () => ({
        item: { 
            qiz_id : 0, qiz_id_parent : null,
            qiz_sta_id : 'GEN01', qiz_typ_id : 'QIZ01', qiz_typ_id_field : 'QTY01',
            qiz_visibility : 1, qiz_name : '', qiz_description : '',
            qiz_color : '', qiz_icon : '', qiz_customfields : {}, qiz_picture : '',
        },
        itemList: [],
        metaItems: null
    }),
    getters: {
        itemTree() {
            var map = {}, node, roots = [], i;
            
            for (i = 0; i < this.itemList.length; i += 1) {
                map[this.itemList[i].qiz_id] = i; // initialize the map
                this.itemList[i].children = []; // initialize the children
            }
            
            for (i = 0; i < this.itemList.length; i += 1) {
                node = this.itemList[i];
                if (node.qiz_id_parent) {
                    // if you have dangling branches check that map[node.parentId] exists
                    this.itemList[map[node.qiz_id_parent]].children.push(node);
                } else {
                    roots.push(node);
                }
            }
            return roots
        }
    },
    actions: {
        fetchItem (id, options) {
            return new Promise( (resolve, reject) => {
                options = (options) ? '/' + options : ''
                if( id && id > 0 ){
                    ApiService.get(ENDPOINT + id + options).then( (response) => {
                        if( !response.data.data.qiz_customfields || Object.prototype.toString.call( response.data.data.qiz_customfields ) === '[object Array]' ) {
                            response.data.data.qiz_customfields = {}
                        }
                        this.SET_ITEM(response.data.data)
                        resolve(this.item)
                    }).catch( (error) => { 
                        reject(error)
                    })
                } else {
                    this.RESET_ITEM()
                    resolve(this.item)
                }
            })
        },
        fetchItems (options) {
            return new Promise( (resolve, reject) => {
                this.SET_ITEMS([])
                options = (options) ? options : ''
                ApiService.get( ENDPOINT + options ).then( (response) => {
                    this.metaItems = response.data.meta
                    if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                        this.SET_ITEMS(response.data.data)
                    }
                    resolve('resolved')
                }).catch( (error) => { 
                    reject(error)
                })
            })
        },
        storeItem () {
            return new Promise( (resolve, reject) => {
                ApiService.post( ENDPOINT, this.item ).then( (response) => {
                    this.SET_ITEM(response.data.data)
                    resolve(this.item)
                }).catch( (error) => { 
                    reject(error)
                })
            })
        },
        updateItem () {
            return new Promise( (resolve, reject) => {
                ApiService.put( ENDPOINT + this.item[ITEM_ID], this.item ).then( (response) => {
                    this.SET_ITEM(response.data)
                    resolve(this.item)
                }).catch( (error) => { 
                    reject(error)
                })
            })
        },
        destroyItem (id) {
            return new Promise( (resolve, reject) => {
                this.item[ITEM_ID] = (id) ? id : this.item[ITEM_ID]
                ApiService.delete(ENDPOINT + this.item[ITEM_ID]).then( () => {
                    this.RESET_ITEM()
                    resolve('resolved')
                }).catch( (error) => { 
                    reject(error)
                })
            })
        },
        //***************************MUTATIONS ***************************************/
        SET_ITEM (item) {
        this.item = item
        },
        SET_ITEMS (itemList) {
        this.itemList = itemList
        },
        RESET_ITEM () {
            this.item = {
                qiz_id : 0, qiz_id_parent : null,
                qiz_sta_id : 'GEN01', qiz_typ_id : 'QIZ01', qiz_typ_id_field : 'QTY01',
                qiz_visibility : 1, qiz_name : '', qiz_description : '',
                qiz_color : '', qiz_icon : '', qiz_customfields : {}, qiz_picture : '',
            }
        }
    }
})
